<template>
  <div class="container-fluid my-3 record" style="min-height:50vh">
    <popUp v-if="toggle" v-on:doClose="close" :size="'large'">
      <div class="pop-title" slot="title">
      </div>
      <div slot="title">
        <h1 class="mx-3 mb-2" style="font-weight:600">{{ copy.radarChart }}</h1>
      </div>
      <div slot="left-box" class="info-main mt-3 d-flex  align-items-center  justify-content-center rwd-hide" v-if="datasets" >
        <RadarChart class=" m-auto" :datasets="datasets" />
      </div>
      <div slot="right-box" class=" mt-3 d-flex  align-items-center  justify-content-center " v-if="datasets" >
        <div class="info-main">
          <h4 class="mb-3" style="font-weight:600">{{ copy.averageScore }}: {{ radarInfo.Score }}</h4>
          <span>{{ copy.speakingAssessment }}</span>
          <ul
            class="score-info list-group list-group-horizontal"
            v-for="([key, item], index) in orderedScores"
            :key="key"
          >
            <li style="min-width: 120px;max-width: 120px;" class="score-title list-group-item">{{ tableTranslate(key) }}</li>
            <li style="min-width: 120px;max-width: 120px;" class="score score-content list-group-item">{{ item }}</li>
          </ul>
        </div>
      </div>
      <div class="radarInfo my-3 rwd-hide" v-if="radarInfo" slot="feedback">
        <hr>
        <button type="button" @click="playAudio('original', currentNo)" class="btn btn-outline-secondary mx-2">{{ copy.courseAudio }}</button>
        <button type="button" @click="playAudio('audio', currentNo)" class="btn btn-outline-secondary">{{ copy.myRecording }}</button>
        <br/>
        <span class="badge badge-success">{{ copy.good }}</span>
        <span class="badge badge-warning mx-2">{{ copy.fair }}</span>
        <span class="badge badge-danger">{{ copy.keepTrying }}</span>
        <div class="pointer mt-2">
          <span style="font-weight:600;weight:200px">{{ copy.courseSentence }}:</span>
          {{radarInfo.Text}}
        </div>
        <div>
          <span style="font-weight:600">{{ copy.myVoice }}: </span>
          <span v-html="applyColorToWords(radarInfo.Text, radarInfo.Words)"></span>
        </div>
      </div>
    </popUp>
    <div class="row">
      <div class="col-12">
        <div class="d-flex menu">
          <div @click="goTitlePage('Room')"  class="title d-sm-flex pointer" :class="{'active' : title === 'Room'}">
            <div class="my-auto">
              {{ copy.roomSetting }}
            </div>
          </div>
          <div @click="goTitlePage('Score')" class="title  d-sm-flex pointer" :class="{'active' : title === 'Score'}">
            <div class="my-auto">
              {{ copy.examScore }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="col-12" style="min-height:40vh">
        <div class="mt-3 d-flex align-items-center justify-content-end filter-bar">
          <select class="filter-select" v-model="pageSize">
            <option value="10" selected>{{ pageSizeText(10) }}</option>
            <option value="50" >{{ pageSizeText(50) }}</option>
            <option value="100" >{{ pageSizeText(100) }}</option>
          </select>
          <button :disabled="selectedList.length==0" type="button" @click="downloadReport()" class="btn btn-primary">{{ copy.sendSelectedReports }}</button>
        </div>
        <div>
          <table class="rwd-table mt-3" v-if="step===0">
          <thead>
            <tr>
              <th colspan="7" class="main-title">{{ copy.roomList }}</th>
            </tr>
          </thead>
            <tbody>
              <tr>
                <th>{{ copy.select }}</th>
                <th>{{ copy.roomName }}</th>
                <th>{{ copy.beginAt }}</th>
                <th>{{ copy.endAt }}</th>
                <th>{{ copy.teacherName }}</th>
                <th>{{ copy.personalDetails }}</th>
                <!-- <th>寄送報表</th> -->
              </tr>
              <tr v-for="(item, index) in roomList" :key="index">
                <td :data-th="copy.select" class="px-2" >
                  <input :value="item.id" v-model="selectedList" type="checkbox" id="scales" name="scales" />
                </td>
                <td :data-th="copy.roomName" class="px-2" >
                  {{ displayName(item) }}
                </td>
                <td :data-th="copy.beginAt">
                  {{item.begin_at}}
                </td>
                <td :data-th="copy.endAt">
                  {{item.end_at}}
                </td>
                <td :data-th="copy.teacherName">
                  {{item.creator.name}}
                </td>
                <td :data-th="copy.viewPersonal">
                  <button type="button" @click="goDetail(item)" class="btn btn-primary mx-3">{{ copy.view }}</button>
                </td>
                <!-- <td data-th="寄送報表">
                  <button type="button" @click="downloadReport(item.id)" class="btn btn-primary mx-3">寄送</button>
                </td> -->
              </tr>
            </tbody>
          </table>
          <div style="min-height: 500px;" v-if="step===1">
            <div class="my-2 row">
              <div class="col-12 align-items-center d-flex justify-content-between filter-bar">
                <div class="filter-controls">
                  <span class="mr-1">{{ copy.class }}:</span>
                  <select class="filter-select" v-model="groupSelected">
                    <option value="0" disabled selected>{{ copy.selectClass }}</option>
                    <option v-for="(item, index) in groupList" :key="index" :value="item.g_id">
                      <span>
                        {{ displayGroupName(item) }}
                      </span>
                    </option>
                  </select>
                </div>
                <button @click="downloadExcel()" type="button" class="btn btn-primary">{{ copy.downloadRoomScores }}</button>
              </div>
            </div>
            <table class="rwd-table mt-3" >
              <tbody>
                <tr>
                  <th>{{ copy.name }}</th>
                  <th>{{ copy.studentNo }}</th>
                  <th>{{ copy.averageScore }}</th>
                  <th>{{ copy.details }}</th>
                </tr>
                <tr v-for="(item, index) in studentList" :key="index">
                  <td :data-th="copy.name">
                    {{ displayName(item) }}
                  </td>
                  <td :data-th="copy.studentNo">
                    {{item.employee_id }}
                  </td>
                  <td :data-th="copy.averageScore">
                    <!-- attended 判斷應考狀況 分數為null顯示進行中 -->
                    {{ studentScoreText(item) }}
                  </td>
                  <td :data-th="copy.details">
                    <button @click="selectedStudent(item.s_id)" type="button" class="btn btn-primary">{{ copy.details }}</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <button @click="step--" type="button" class="btn btn-primary my-3" style="float: right;">{{ copy.back }}</button>
          </div>
          <div style="min-height: 500px;" v-if="step===2">
            <div class="my-2 row detail-filter-row">
              <div class="col-md-3 filter-field">
                {{ copy.currentAverageScore }}:{{ score }}
              </div>
              <div class="col-md-6 filter-field">
                <span class="mr-1">{{ copy.question }}:</span>
                <select class="filter-select" v-model="oralSelected">
                  <option v-for="(item, index) in oralList" :key="index" :value="index">
                    <span>
                      {{ displayName(item) }}
                    </span>
                  </option>
                </select>
              </div>
              <div class="col-md-3 filter-field">
                <span class="mr-1">{{ copy.student }}:</span>
                <select class="filter-select" v-model="studentSelected">
                  <option value="0" disabled selected>{{ copy.selectStudent }}</option>
                  <option v-for="(item, index) in studentList" :key="index" :value="item.s_id">
                    <span>
                      {{ displayName(item) }}
                    </span>
                  </option>
                </select>
              </div>
            </div>
            <table class="rwd-table mt-3" >
              <tbody>
                <tr>
                  <th>{{ copy.sentence }}</th>
                  <th>{{ copy.audio }}</th>
                  <th>{{ copy.score }}</th>
                  <th>{{ copy.radarChart }}</th>
                </tr>
                <tr v-for="(item, index) in sentences" :key="index">
                  <td class="pointer" :data-th="copy.sentence" @click="playAudio('original', item.no)">
                    {{item.text}}
                    <audio :id="`originalAudio${item.no}`">
                      <source :src="item.audio" type="audio/wav" />
                    </audio>
                  </td>
                  <td :data-th="copy.audio">
                    <audio :id="`audio${item.no}`" controls>
                      <source :src="item.audio_url" type="audio/wav" />
                    </audio>
                  </td>
                  <td :data-th="copy.score">
                    {{item.score !== null ? item.score : 0}}
                  </td>
                  <td :data-th="copy.radarChart">
                    <button style="white-space:nowrap;" v-if="item.data" type="button" @click="openRadarInfo(item.data, item.no)" class="btn btn-primary mx-3">{{ copy.view }}</button>
                    <button style="white-space:nowrap;" v-else type="button" disabled class="btn btn-primary mx-3">{{ copy.view }}</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <button @click="step--" type="button" class="btn btn-primary my-3" style="float: right;">{{ copy.back }}</button>
          </div>
        </div>
      </div>
      <div>
        <pagination v-if="step===0 && pageCount>1" class="m-auto pt-4" :current="pageIndex" :total="pageCount" v-on:page="toPage"/>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import Pagination from '@/components/Pagination.vue'
import PopUp from '@/components/PopUp.vue'
import moment from 'moment';
import RadarChart from '@/components/RadarChart.vue'
import 'vue2-datepicker/index.css';
import api from '../../../store/api'
export default {
  name: 'Exam-detail',
  data () {
    return {
      title: 'Score',
      step: 0,
      examId: 0,
      roomList: [],
      selectedList: [],
      examData: null,
      groupList: [],
      currentExam: '',
      studentList: [],
      oralList: [],
      groupSelected: 0,
      studentSelected: 0,
      oralSelected: 0,
      sentences: null,
      datasets: null,
      score: 0,
      toggle: false,
      radarInfo: null,
      feedback: null,
      currentNo: 0,
      pageIndex: 1,
      pageCount: 0,
      pageSize: 100,
    }
  },
  components: {
    PopUp,
    Pagination,
    RadarChart
  },
  watch: {
    groupSelected (val) {
      this.getStudentList(val)
    },
    oralSelected (val) {
      this.getSentences(this.examId, val)
    },
    studentSelected (val) {
      this.getSentences(this.examId, 0)
    },
    pageSize (val) {
      this.pageIndex = 1
      this.getRoomList()
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n ? this.$i18n.locale : 'tw'
    },
    copy () {
      const copy = {
        tw: {
          roomSetting: '考場設定',
          examScore: '考試成績',
          showRows: '顯示{count}筆',
          sendSelectedReports: '寄送選取報表',
          roomList: '考場列表',
          select: '選取',
          roomName: '考場名稱',
          beginAt: '開始時間',
          endAt: '結束時間',
          teacherName: '老師姓名',
          personalDetails: '個人詳情',
          viewPersonal: '查看個人',
          view: '查看',
          class: '班級',
          selectClass: '請選擇班級',
          downloadRoomScores: '下載考場成績',
          name: '姓名',
          studentNo: '學號',
          averageScore: '平均分數',
          details: '詳情',
          notAttended: '未應考',
          inProgress: '進行中',
          back: '回上頁',
          currentAverageScore: '本題平均成績',
          question: '題目',
          student: '學生',
          selectStudent: '請選擇學生',
          sentence: '句子',
          audio: '音檔',
          score: '成績',
          radarChart: '能力雷達圖',
          speakingAssessment: '口說練習評估結果如下:',
          courseAudio: '課程音檔',
          myRecording: '我的錄音',
          good: '良好',
          fair: '尚可',
          keepTrying: '再加油',
          courseSentence: '課程句子',
          myVoice: '我的聲音',
          accuracy: '精確度',
          fluency: '流暢度',
          completeness: '完整性',
          prosody: '韻　律',
          unknown: '未知',
          unsupportedMentorAi: '目前版本不支持MentorAi',
          emailTitle: '請輸入email',
          emailText: '報表將同步寄送此信箱，若不需要請留空。',
          reportSuccess: '報表計算完成後，將自動發送至您的信箱',
          reportError: '目前報表功能異常，請聯絡管理者',
          confirm: '確定'
        },
        en: {
          roomSetting: 'Exam Room Settings',
          examScore: 'Exam Scores',
          showRows: 'Show {count}',
          sendSelectedReports: 'Send Selected Reports',
          roomList: 'Exam Room List',
          select: 'Select',
          roomName: 'Exam Room Name',
          beginAt: 'Start Time',
          endAt: 'End Time',
          teacherName: 'Teacher',
          personalDetails: 'Personal Details',
          viewPersonal: 'View Personal',
          view: 'View',
          class: 'Class',
          selectClass: 'Select a class',
          downloadRoomScores: 'Download Exam Room Scores',
          name: 'Name',
          studentNo: 'Student ID',
          averageScore: 'Average Score',
          details: 'Details',
          notAttended: 'Not Attended',
          inProgress: 'In Progress',
          back: 'Back',
          currentAverageScore: 'Average Score for This Question',
          question: 'Question',
          student: 'Student',
          selectStudent: 'Select a student',
          sentence: 'Sentence',
          audio: 'Audio',
          score: 'Score',
          radarChart: 'Ability Radar Chart',
          speakingAssessment: 'Speaking practice assessment results:',
          courseAudio: 'Course Audio',
          myRecording: 'My Recording',
          good: 'Good',
          fair: 'Fair',
          keepTrying: 'Keep Trying',
          courseSentence: 'Course Sentence',
          myVoice: 'My Voice',
          accuracy: 'Accuracy',
          fluency: 'Fluency',
          completeness: 'Completeness',
          prosody: 'Prosody',
          unknown: 'Unknown',
          unsupportedMentorAi: 'This version does not support MentorAi.',
          emailTitle: 'Enter email',
          emailText: 'The report will also be sent to this email address. Leave it blank if not needed.',
          reportSuccess: 'The report will be sent to your inbox after it is generated.',
          reportError: 'The report feature is currently unavailable. Please contact an administrator.',
          confirm: 'OK'
        }
      }

      return copy[this.currentLocale] || copy.tw
    },
    groupId () {
      return this.$route.params.groupId
    },
    orderedScores() {
      const order = [
        'AccuracyScore',
        'FluencyScore',
        'CompletenessScore',
        'ProsodyScore'
      ]
      return order.map(key => [key, this.radarInfo.Scores[key]])
    }
  },
  mounted () {
    this.getRoomList()
    this.audiosLoad()
  },
  methods: {
    async getRoomList () {
      const { data } = await api.get(`liveabc/rooms?group_id=${this.groupId}&page=${this.pageIndex}&pageSize=${this.pageSize}`)
      this.roomList = data.data
      this.pageCount = data.pageCount
      this.pageIndex = data.pageIndex
    },
    async getExamData (id) {
      const { data } = await api.get(`liveabc/rooms/${id}/students?page=$1&pageSize=1000`)
      this.examData = data.data
      const set = new Set()
      this.groupList = data.data.filter(item=>!set.has(item.g_id)?set.add(item.g_id): false)
      this.groupSelected = this.groupList[0].g_id
    },
    async getOralList (id) {
      const { data } = await api.get(`liveabc/rooms/${id}/oral_contents`)
      this.oralList = data.data
    },
    getStudentList (id) {
      this.studentList = this.examData.filter(item => item.g_id === id)
    },
    goDetail(el) {
      this.step += 1
      this.examId = el.id
      this.currentExam = el.name
      this.groupSelected = 0
      this.studentSelected = 0
      this.oralSelected = 0
      this.getExamData(el.id)
      this.getOralList(el.id)
      this.getSentences(el.id, 0)
    },
    async getSentences (id, idx) {
      const { data } = await api.get(`liveabc/rooms/${id}/students/${this.studentSelected}/answers`)
      this.sentences = data.data.lessons[idx].sentences
      this.score = data.data.lessons[idx].score
      this.audiosLoad()
    },
    goTitlePage (el) {
      this.title = el
      this.$router.push({ name: el, params:{ groupId: this.groupId}})
    },
    selectedStudent(id) {
      this.studentSelected = id
      this.step += 1
    },
    openRadarInfo (el, no) {
      this.pauseAll()
      this.radarInfo = el
      // this.mergedFeedback(el)
      this.currentNo = no
      if (el.Scores) {
        this.openRadarChart(el.Scores)
      } else {
        alert(this.copy.unsupportedMentorAi)
      }
    },
    openRadarChart (el) {
      const data = {
        'PronScore' : 0,
        'AccuracyScore': 0,
        'CompletenessScore': 0,
        'FluencyScore': 0,
        'ProsodyScore': 0
      }
      const order = [
        'PronScore',
        'AccuracyScore',
        'CompletenessScore',
        'FluencyScore',
        'ProsodyScore'
      ]
      const arr = order.map(key => el[key] ?? data[key])
      this.datasets = {
        labels: [ this.copy.averageScore, this.copy.accuracy, this.copy.fluency, this.copy.completeness, this.copy.prosody],
        datasets: [
          {
            label: '',
            backgroundColor: '#f87979a5',
            radius: 6,
            pointRadius: 6,
            pointBorderWidth: 3,
            data: arr,
            borderColor: '#f87979',
          }
        ]
      }
      this.toggle = true
    },
    close (close) {
      this.toggle = close
      this.pauseAll()
      this.radarInfo = null
      this.currentNo = 0
    },
    toPage (toPage) {
      this.pageIndex = toPage
      this.getRoomList()
    },
    audiosLoad () {
      const audios = document.getElementsByTagName('audio')
      for (let i = 0; i < audios.length; i++) {
        audios[i].load();
      }
    },
    getPartNameFromIndex (index) {
      switch (index) {
        case 'AccuracyScore':
          return 'Accuracy'
        case 'FluencyScore':
          return 'Fluency'
        case 'CompletenessScore':
          return 'Completeness'
        case 'ProsodyScore':
          return 'Prosody'
        default:
          return 'unknown'
      }
    },
    tableTranslate (el) {
      switch (el) {
        case 'AccuracyScore':
          return this.copy.accuracy
        case 'FluencyScore':
          return this.copy.fluency
        case 'CompletenessScore':
          return this.copy.completeness
        case 'ProsodyScore':
          return this.copy.prosody
        default:
          return this.copy.unknown
      }
    },
    mergedFeedback (el) {
      const part_feedback = el.part_feedback
      const part_scoresArray = el.part_scores
      const part_scores = {}
      part_scoresArray.forEach((score, index) => {
        const partName = this.getPartNameFromIndex(index)
        part_scores[partName] = score
      })
      const mergedFeedback = {}
      for (const part in part_feedback) {
        if (part_scores.hasOwnProperty(part)) {
          mergedFeedback[part] = {
            feedback: part_feedback[part],
            score: part_scores[part]
          }
        }
      }
      this.feedback = mergedFeedback
    },
    playAudio (type, id) {
      // this.current = id
      if (type == 'original') {
        let audio = document.getElementById(`originalAudio${id}`)
        this.pauseAll()
        audio.load()
        audio.play()
      } else {
        let audio = document.getElementById(`audio${id}`)
        this.pauseAll()
        audio.load()
        audio.play()
      }
    },
    pauseAll () {
      const audios = document.getElementsByTagName('audio')
      const self = this
      const allAudios = []
      allAudios.forEach.call(audios, function (i) {
        i.currentTime = 0
        i !== self && i.pause()
      })
    },
    mapErrorTypeToStatus (errorType) {
      switch (errorType) {
        case "None":
          return 0; // green
        case "Mispronunciation":
        case "Monotone":
          return 1; // orange
        case "Omission":
          return 2; // red
        default:
          return null; // 不顯示
      }
    },
    applyColorToWords(text, wordStatus) {
      const statusToColor = {
        "0": "green",
        "1": "orange",
        "2": "red"
      }
      // 建立一個可變的 wordStatus 副本，以便我們可以使用和移除項目
      const availableWordStatus = [...wordStatus]
      // 拆開字與標點
      const wordsWithPunctuation = text.match(/[\w'$-]+|[.,!?;:]/g)
      if (!wordsWithPunctuation) {
        return text // 如果沒有匹配到任何單字或標點，直接返回原文本
      }
      const colorizedWords = wordsWithPunctuation.map(word => {
        if (/[\w'$-]+/.test(word)) {
          // 尋找第一個匹配的、尚未使用的狀態的索引
          const statusIndex = availableWordStatus.findIndex(
            item => item.Word.trim().toLowerCase() === word.trim().toLowerCase() && item.ErrorType !== "Insertion"
          )
          if (statusIndex !== -1) {
            // 取得狀態物件，並將其從可用列表中移除
            const [statusObj] = availableWordStatus.splice(statusIndex, 1)
            const status = this.mapErrorTypeToStatus(statusObj.ErrorType)
            if (status !== null && status !== -1) {
              const color = statusToColor[status.toString()]
              return `<span style="color: ${color};">${word}</span>`
            }
          }
          return word
        } else {
          return word // 標點符號保留
        }
      })
      return colorizedWords.join(' ')
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    export2Excel (list) {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../../vendor/Export2Excel')
        const tHeader = [ this.copy.class, this.copy.name, this.copy.studentNo, this.copy.averageScore]
        const filterVal = [ 'group_name', 'name', 'employee_id' ,'score' ]
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, this.currentExam)
      })
    },
    downloadExcel () {
      this.export2Excel(this.examData)
    },
    pageSizeText (count) {
      return this.copy.showRows.replace('{count}', count)
    },
    studentScoreText (item) {
      return item.attended === false ? this.copy.notAttended : item.score ? item.score : this.copy.inProgress
    },
    displayName (item) {
      if (!item) {
        return ''
      }

      if (this.currentLocale === 'en') {
        return item.name_en || item.display_name || item.name || ''
      }

      return item.name || item.display_name || item.name_en || ''
    },
    displayGroupName (item) {
      if (!item) {
        return ''
      }

      if (this.currentLocale === 'en') {
        return item.group_name_en || item.group_name || ''
      }

      return item.group_name || item.group_name_en || ''
    },
    async downloadReport () {
      const vm = this
      console.log(this.selectedList)
      vm.$swal({
        title: vm.copy.emailTitle,
        text: vm.copy.emailText,
        input: 'text',
        inputAttributes: {
          autocapitalize: "off"
        },
        showCancelButton: true,
        inputValidator: function(value) {
          return new Promise(function(resolve, reject) {
            try {
              api.get(`reports/rooms?roomIds=${vm.selectedList}?cc=${value}`)
              vm.$swal({
                title: vm.copy.reportSuccess,
                icon: 'success',
                showCancelButton: false,
                confirmButtonText: vm.copy.confirm
              })
            } catch (error) {
              if (error) {
                vm.$swal({
                  title: vm.copy.reportError,
                  icon: 'error',
                  showCancelButton: false,
                  confirmButtonText: vm.copy.confirm
                })
              }
            }
            resolve()
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/styles/color.scss";
.record {
  text-align: left;
  .layout {
    min-height: 50vh;
  }
}
.menu {
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  .title {
    margin: 10px 30px 10px 0;
  }
}
.active {
  // color: red;
  font-weight: bolder;
}
.filter-bar {
  flex-wrap: wrap;
  gap: 12px 16px;
}
.filter-controls,
.filter-field {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  min-width: 0;
}
.detail-filter-row {
  row-gap: 12px;
}
.filter-select {
  max-width: min(100%, 560px);
  padding: 3px 8px;
}
  table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  th {
    overflow:hidden;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }

  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .rwd-table {
    margin: auto;
    min-width: 300px;
    max-width: 100%;
    border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table tbody th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
.main-title {
  background: rgb(24, 97, 255);
  border: none !important;
}
.score-info {
  font-size: 1.2rem;
  .score-title {
    border-color: #fff !important;
    border-width: 3px !important;
    background-color: #418BCA;
    color: #fff;

  }
  .score {
    font-weight: 600;
  }
  .score-content {
    background-color: #E9F8FF;
    border-color: #fff !important;
    border-width: 3px !important;
  }
}
.radarInfo {
  font-size: 1.25rem;
}
.good {
  color: green;
}
.bad {
  color: red;
}
.normal {
  color:orange;
}
.wrong {
  color: rgba(0, 0, 0, 0.4);
}
@media screen and (max-width: 601px) {
  .rwd-hide {
    display: none !important;
  }
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}

@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table tbody th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>
